import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import {Injectable} from '@angular/core';
import {Headers, Http, Jsonp, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';

import {environment} from '../../../environments/environment';
import {AuthBody} from '../model/authBody';
import {AuthResponse} from '../model/authResponse';
import {ErrorResponse} from '../model/errorResponse';
import {SessionService} from './session.service';

const API_URL = environment.apiUrl;

@Injectable()
export class AuthService {
  private headers = new RequestOptions(
      {headers: new Headers({'Content-Type': 'application/json'})});

  constructor(private http: Http, private sessionService: SessionService) {}

  public login(email: string, password: string, twoFactorCode?: string): Observable<AuthResponse> {
    const body: any = {email: email, password: password};
    if (twoFactorCode) {
      body['2fa_code'] = twoFactorCode;
    }

    return this.http
        .post(API_URL + '/v1/auth', JSON.stringify(body), this.headers)
        .map(response => {
          return new AuthResponse(response.json());
        })
        .catch(this.handleError);
  }

  public setupTwoFactor(): Observable<any> {
    return this.http
        .post(API_URL + '/v1/auth/2fa/setup', JSON.stringify({}), this.getAuthenticatedJsonHeaders())
        .map(response => {
          return response.json();
        })
        .catch(error => this.sessionService.handleAuthenticatedRequestError(error));
  }

  public enableTwoFactor(twoFactorCode: string): Observable<AuthResponse> {
    return this.http
        .post(
            API_URL + '/v1/auth/2fa/enable',
            JSON.stringify({'2fa_code': twoFactorCode}),
            this.getAuthenticatedJsonHeaders())
        .map(response => {
          return new AuthResponse(response.json());
        })
        .catch(error => this.sessionService.handleAuthenticatedRequestError(error));
  }

  public disableTwoFactor(twoFactorCode: string): Observable<AuthResponse> {
    return this.http
        .post(
            API_URL + '/v1/auth/2fa/disable',
            JSON.stringify({'2fa_code': twoFactorCode}),
            this.getAuthenticatedJsonHeaders())
        .map(response => {
          return new AuthResponse(response.json());
        })
        .catch(error => this.sessionService.handleAuthenticatedRequestError(error));
  }

  private getAuthenticatedJsonHeaders(): RequestOptions {
    return new RequestOptions({
      headers: new Headers({
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    });
  }

  private handleError(error: Response) {
    return Observable.throw(new ErrorResponse(error.json()));
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/services/auth.service.ts